import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Home } from './Home';
import { FAQVideo } from './FAQVideo';
import { Pamphlet } from './Pamphlet';
import { About } from './About';
import { Contact } from './Contact'

export class Main extends Component {
    render() {
        return (
            <div className="content">
                <Switch>
                    <Route exact path='/faqvideo' component={FAQVideo} />
                    <Route exact path='/pamphlet' component={Pamphlet} />
                    <Route exact path='/about' component={About} />
                    <Route exact path='/contact' component={Contact} />
                    <Route default path='/' component={Home} />
                </Switch>
            </div>
        );
    }
}